import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10a7339c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))

import { QuizzAnswer } from '@/types/Quizz'
import QuizzIllustrationCard from './QuizzIllustrationCard.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    answer: null,
    isUsed: { type: Boolean }
  },
  emits: ['on-drop', 'on-drag-over'],
  setup(__props: any, { emit }) {

const props = __props as {
  answer: QuizzAnswer
  isUsed: boolean
}





function onDragOver(ev: Event) {
  emit('on-drag-over', ev)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onDrop(ev: any) {
  emit('on-drop', ev)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "quizz-illustration-answer",
    id: `quizz-illustration-answer-${__props.answer.id}`,
    onDrop: onDrop,
    onDragover: onDragOver
  }, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(QuizzIllustrationCard, {
        id: props.answer.id,
        "is-draggable-element": true,
        answer: props.answer.answer,
        draggable: "true",
        disabled: __props.isUsed
      }, null, 8, ["id", "answer", "disabled"])
    ])
  ], 40, _hoisted_1))
}
}

})